import React from 'react';
import './style.scss'
import { Link } from 'react-router-dom'

import Table from 'react-bootstrap/Table'

import Menu from '../../components/Menu'
import Footer from '../../components/Footer'
import MedalLink from '../../components/MedalsEbit-Link'

import Img1 from '../../assets/imagens/img-logista-small.b8bcf00f.JPG'

import Step1 from '../../assets/imagens/Passo1.6344460b.JPG'
import Step2 from '../../assets/imagens/Passo2a.233b60ec.JPG'
import Step3 from '../../assets/imagens/Passo3.d22d5fcf.JPG'
import Step4 from '../../assets/imagens/Passo4.3a93e37d.JPG'
import ImgShopper from '../../assets/imagens/img-shopper01.ad471829.jpg'

import ImgPoints1 from '../../assets/imagens/points-portal1.115181bd.JPG'
import ImgPoints2 from '../../assets/imagens/points-portal2.51a9c041.JPG'
import ImgPoints3 from '../../assets/imagens/points-portal3.829589c5.JPG'
import ImgPoints4 from '../../assets/imagens/points-portal4.6cef7604.JPG'
import ImgPoints5 from '../../assets/imagens/points-portal5.b9e65c7e.JPG'
import ImgPoints6 from '../../assets/imagens/points-portal6.8df364ad.JPG'
import ImgBinario from '../../assets/imagens/binario.JPG'
import ImgData from '../../assets/imagens/data.JPG'
import Medalha from '../../assets/imagens/medalha-diamante.png'
import Banner from '../../assets/imagens/Banner-ebit.42b357db.png'

import Icon1 from '../../assets/imagens/icon-white-red-Benchmark.13983b35.svg'
import Icon2 from '../../assets/imagens/icon-white-red-ShoppingCart.5d86bcf3.svg'
import Icon3 from '../../assets/imagens/icon-white-red-Solving.8b7aaaec.svg'
import Icon4 from '../../assets/imagens/icon-white-red-Report.4921506a.svg'

import IconUp from '../../assets/imagens/icon-graph-up.JPG'
import WebshoppersFree from '../../assets/imagens/webshoppers/Capa-WB43Free.PNG'
import WebshoppersCustom from '../../assets/imagens/webshoppers/Capa-WB43Capitulos.PNG'
import WebshoppersPremium from '../../assets/imagens/webshoppers/Capa-WB43Premium.PNG'
import Icon02 from '../../assets/imagens/icons/icon-white-red-Content-2.0ae094dd.svg'
import IconContact from '../../assets/imagens/contact-icon.55e901ba.JPG'
import IconTermo from '../../assets/imagens/termo-lojista-icon.JPG'

import LojBanner1 from '../../assets/imagens/img-banner-Lojista-ebit-02.7a382624.png'
import LojBanner2 from '../../assets/imagens/banner-loj.7005a449.jpg'

import NLojista1 from '../../assets/imagens/pag-QueroSerLojista-ebit-02.bd76bf14.png'
import NLojista2 from '../../assets/imagens/pag-QueroSerLojista-ebit-03.5f22c321.png'
import NLojista3 from '../../assets/imagens/pag-QueroSerLojista-ebit-04.png'

import NLojista4 from '../../assets/imagens/pag-QueroSerLojista-ebit-05.png'
import NLojista5 from '../../assets/imagens/pag-QueroSerLojista-ebit-06.163028bb.png'
import NLojista6 from '../../assets/imagens/pag-QueroSerLojista-ebit-07.2090c49e.png'
import NLojista7 from '../../assets/imagens/pag-QueroSerLojista-ebit-08.png'



function NovoLojista() {
  return (
    <>
      <Menu></Menu>

      <section className="banner-premio-ebit">
        <div className="banner-premio-ebit__img-premio1">
          <img src={LojBanner1} alt="Banner Lojista" />
          <div>
            <img src={LojBanner2} alt="Segundo Banner Lojista" />
          </div>
        </div>
      </section>

      <section className="content-portal container">

        <h2>Por que ser um lojista colaborador Ebit | Nielsen?</h2>

        <div className="content-portal__new-Shopper01">
          <div className="cards-new-shopper">
            <img src={NLojista1} alt="" />
            <h5>Aumente seu tráfego, conversão e melhorias de SEO</h5>
            <p>Sua página é classificada dentro da busca do site Ebit | Nielsen, ganha alcance e links que com nossa autoridade no apontamento para seu e-commerce. Isso contribui para melhorar a classificação de seu site nos mecanismos de busca <br />(Google, Bing, etc).</p>
          </div>

          <div className="cards-new-shopper">
            <img src={NLojista2} alt="" />
            <h5>Credibilidade para seu e-commerce e confiança para o consumidor</h5>
            <p>Atestamos seu desempenho. As medalhas transmitem confiança ao consumidor na hora de comprar em sua loja virtual.</p>
          </div>

          <div className="cards-new-shopper">
            <img src={NLojista3} alt="" />
            <h5>Visibilidade sobre o mercado</h5>
            <p>Conheça particularidades de seu segmento de mercado. Tenha acesso gratuito às métricas que influenciam em decisões estratégicas de seu e-commerce.</p>
          </div>
        </div>


        <h2>o que encontro no portal EBIT | NIELSEN?</h2>

        <div className="content-portal__style">
          <div className="content-portal__style__bg-img">
            <img src={ImgShopper} alt="Foto" />
          </div>

          <div className="content-portal__style__infos">
            <div className="text-infos">
              <p className="lead">Além da credibilidade que a Ebit | Nielsen proporciona para o seu e-commerce, toda loja conveniada tem acesso a diversos relatórios gratuitos sobre o desempenho do seu e-commerce na visão dos consumidores. </p>
              <p className="lead">Os relatórios foram desenhados segundo 6 grandes temas abaixo:</p>
            </div>

            <div className="points-infos">
              <div className="points-infos__div-main">
                <img src={ImgPoints1} alt="" />
              </div>

              <div className="points-infos__div-main">
                <img src={ImgPoints2} alt="" />
              </div>

              <div className="points-infos__div-main">
                <img src={ImgPoints3} alt="" />
              </div>

              <div className="points-infos__div-main">
                <img src={ImgPoints4} alt="" />
              </div>

              <div className="points-infos__div-main">
                <img src={ImgPoints5} alt="" />
              </div>

              <div className="points-infos__div-main">
                <img src={ImgPoints6} alt="" />
              </div>

            </div>

          </div>
        </div>

        <h5>E a liberação  deles é feita em duas etapas:</h5>

        <div className="content-portal__release-steps">
          <div className="style1">
            <img src={ImgBinario} alt="" />
            <div>
              <h6>Colaboração Simples:</h6>
              <p className="lead">liberada para lojistas que enviam no <strong>MINIMO 30%</strong> do Score</p>
            </div>
          </div>

          <div className="style1">
            <img src={ImgData} alt="" />
            <div>
              <h6>Colaboração Completa:</h6>
              <p className="lead">liberada para lojistas que enviam no <strong>MINIMO 70%</strong> do Score</p>
            </div>
          </div>
        </div>

        <div className="content-portal__table-params">

          <Table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th class="name-color td1">RELATÓRIOS DISPONÍVEIS</th>
                <th className="name-color">COLABORAÇÃO SIMPLES (MINIMO 30% do Score)</th>
                <th className="name-color">COLABORAÇÃO COMPLETA (MINIMO 70% do Score)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="td1">NPS</td>
                <td class="td2">Avaliação de Compra</td
                ><td class="td2">Avaliação de Entrega e Completo</td>
              </tr>
              <tr>
                <td class="td1">Indicadores de Desempenho</td>
                <td class="td2">Mensal</td>
                <td class="td2">Diário e Semanal</td>
              </tr>
              <tr>
                <td class="td1">Comentários</td>
                <td class="td2">Simplificado</td>
                <td class="td2">Completo</td>
              </tr>
              <tr>
                <td class="td1">Medalha</td>
                <td class="td2">% de Entrega no prazo e Evolução da quantidade de pesquisa</td>
                <td class="td2"> - </td>
              </tr>
              <tr>
                <td class="td1">Consumidor</td>
                <td class="td2">Perfil Demográfico</td>
                <td class="td2"> - </td>
              </tr>
              <tr>
                <td class="td1">Dados transacionais</td>
                <td class="td2">NA</td>
                <td class="td2">Top 50 produtos e Pedidos - Semanal</td>
              </tr>
            </tbody>
          </Table>
        </div>
        <p className="lead ">
          Quanto mais parâmetros nos enviar, maior benefício terá seus consumidores (que responderão uma pesquisa bem menor ) e também você lojista (que terá um maior número de respondentes, além de dados de maior qualidade).
        </p>
      </section>

      <div className="description-associate container">
        <h2>Como se tornar um coloborador Ebit | Nielsen?</h2>
        <p className="lead ">Para se tornar um colaborador Ebit | Nielsen não existe nenhum custo de adesão, basta seguir o passo a passo abaixo:</p>
      </div>
      <div className="new-Shopper02 container">
        <div className="cards-new-shopper02">
          <img src={NLojista4} alt="" />
          <h6>Solicita o convenio Ebit | Nielsen</h6>
          <p className="lead"> O lojista interessado em conveniar-se à Ebit | Nielsen precisa preencher os dados de cadastro na <a href="https://company.ebit.com.br/cadastro-de-loja"><u>página de adesão.</u></a></p>
        </div>

        <div className="cards-new-shopper02">
          <img src={NLojista5} alt="" />
          <h6>Implementar as medalhas</h6>
          <p className="lead"> Após ser aprovado e se conveniar à Ebit | Nielsen é necessário implementar a medalha <b>em todas as páginas</b>  da loja de acordo com as instruções da equipe de atendimento comercial.</p>
        </div>

        <div className="cards-new-shopper02 imgS3">
          <img src={NLojista6} alt="" />
          <h6>Banner na página de confirmação de compra</h6>
          <p className="lead">O banner deve ser implementado <b>única e exclusivamente</b>  na página de finalização da compra para garantir que as pesquisas de satisfação da loja sejam respondidas por consumidores reais no momento da compra. </p>
        </div>

        <div className="cards-new-shopper02 imgS4">
          <img src={NLojista7} alt="" />
          <h6>Validação de integração</h6>
          <p className="lead">Após implementar corretamente as medalhas e o banner é preciso validar a integração com a equipe de atendimento comercial e solicitar homologação da loja com a área de suporte.</p>
        </div>
      </div>

      <section className="new-shopper1 container">
        <a href="https://company.ebit.com.br/cadastro-de-loja">
          <div>Quero ser um colaborador!</div>
        </a>
      </section>

      <section>
        <div className="ebit-numeros container-fluid">
          <div className="container">
            <div className="title-ebit-numeros">
              <p>Ebit | Nielsen em números</p>
            </div>

            <div className="info-ebit-numeros lead">
              <p className="lead">Pioneira em realizar pesquisas online que visam analisar  e entender o perfil e hábitos do consumidor virtual</p>
            </div>

            <div className="display-ebit-numeros">
              <div className="display-ebit-numeros__items-ebit-numero ">
                <img src={Icon1} alt="Icone barra" />
                <p className="numero-ebit">+de 10 mil</p>
                <p className="info-numeros-ebit">Pesquisas respondidas por dia</p>
              </div>

              <div className="display-ebit-numeros__items-ebit-numero">
                <img src={Icon4} alt="Icone barra" />
                <p className="numero-ebit">97 mil</p>
                <p className="info-numeros-ebit">Lojas avaliadas até <br /> o momento</p>
                <small className="form-text text-muted"><i>Lojas que já tiveram cadastro em algum momento no Ebit | Nielsen</i></small>
              </div>

              <div className="display-ebit-numeros__items-ebit-numero">
                <img src={Icon2} alt="Icone Check" />
                <p className="numero-ebit">720 mil</p>
                <p className="info-numeros-ebit">pedidos registrados por dia em média</p>
                <small className="form-text text-muted"><i>Média de Janeiro a Maio de 2020</i></small>
              </div>

              <div className="display-ebit-numeros__items-ebit-numero">
                <img src={Icon3} alt="Icone Carrinho de compra" />
                <p className="numero-ebit">1 milhão</p>
                <p className="info-numeros-ebit">de itens recebidos por dia</p>
                <small className="form-text text-muted"><i>Aproximadamente</i></small>
              </div>
            </div>
          </div>
        </div>
      </section>

      <MedalLink />

      <section className="solutions-ebit container">
        <h2>SOLUÇÕES EBIT | Nielsen</h2>
        <p className="lead">Os questionários respondidos diariamente pelos consumidores abastecem o banco de dados da Ebit | Nielsen, proporcionando <strong>relatórios únicos</strong> que traçam o perfil do consumidor e que avaliam comparativamente e com precisão os serviços prestados pelas lojas virtuais.</p>
        <p className="lead">Possibilitando à Ebit | Nielsen fornecer as seguintes soluções abaixo:</p>

        <div className="solutions-ebit__map-text">
          <h3>Mapeamento Contínuo</h3>
          <div className="style2">
            <div className="style2__contet1">
              <h6>Dados transacionais</h6>
              <ul>
                <li className="lead">Relatórios diários, semanais, mensais e trimestrais</li>
                <li className="lead">Opção de aquisições da back data ou business issue</li>
              </ul>
              <h6>Dados sazonais</h6>
              <ul>
                <li className="lead">Forecast e realizado de 9 datas sazonais</li>
              </ul>
              <h6>Dados pesquisa (compra e entrega)</h6>
              <ul>
                <li className="lead">Apresentação executiva padrão com os resultados das pesquisas e dados de consumidores</li>
              </ul>
            </div>
            <img src={IconUp} alt="Gráfico" />
          </div>
        </div>
      </section>

      <section className="webshoppers container">
        <h2>webshoppers</h2>
        <p className="lead">Estudo realizado duas vezes ao ano (Fechamento de ano e semestre) com o overview do e-commerce daquele período</p>

        <div className="webshoppers__imgs">
          <div>
            <a href="https://company.ebit.com.br/webshoppers/webshoppersfree">
              <img src={WebshoppersFree} alt="Webshoppers Free" />
            </a>
          </div>
          <div>
          <Link to="/webshoppers-capitulos">
            <img src={WebshoppersCustom} alt="Webshoppers Custom" />
          </Link>
        </div>
        <div>
          <Link to="/webshoppers-premium">
            <img src={WebshoppersPremium} alt="Webshoppers Premium" />
          </Link>
        </div>

        </div>

      </section>

      <section className="special-study container">
        <h2>Estudo Especial</h2>
        <div>
          <p className="lead">Aplicações de questionário customizado no painel de consumidores online para responder um problema de negócio específico.</p>
          <img src={Icon02} alt="Icone Arquivo" />
        </div>
      </section>

      <div className="company container">
        <h2 className="h2-title-RL">
        LOJAS COLABORADORAS
        </h2>
        <div>
          <Link to="/reputacao-de-lojas">Clique aqui para verificar todas as lojas coloboradoras Ebit | Nielsen!</Link>
        </div>
      </div>

      <div className="termos">

        <div className="termo-cadastro">
          <img src={IconContact} alt="Icone contato" />
          <div>
            <h6>Termo de cadastro:</h6>
            <p className="lead">Acesse o termo de cadastro <a href="https://company.ebit.com.br/termo-cadastro">clicando aqui</a></p>
          </div>
        </div>

        <div className="termo-cadastro">
          <img src={IconTermo} alt="Icone termo" />
          <div>
            <h6>Termo de uso lojista:</h6>
            <p className="lead">Acesse o termo de uso lojista <a href="https://company.ebit.com.br/termo-lojista">clicando aqui</a></p>
          </div>
        </div>
      </div>

      <div className="business-contact container">
        <h2>Ficou alguma dúvida?</h2>
        <p className="lead"><strong>Entre em contato com nossa equipe: <a href="mailto:comercial@ebit.com.br">comercial@ebit.com.br</a></strong></p>
      </div>
      <Footer></Footer>
    </>
  );
}

export default NovoLojista;